module.exports = __webpack_public_path__ + "img/wales.fae49de9.svg";